<template>
  <form data-form="autosave account-settings">
    <h3 data-section-title="form">Document Font</h3>
    <div data-field="inline-radios font-options">
      <div v-for="{ id, label, value } in inputs" :key="value">
        <UtilityFormRadio
          v-model="formValue"
          :field-id="id"
          :label="label"
          :value="value"
          name="font"
          :disabled="disabled"
        />
      </div>
    </div>
    <UtilitySaveIndicator :state="saving" />
  </form>
</template>

<script lang="ts">
import { v4 as uuid } from 'uuid';
import { computed, defineComponent } from 'vue';

import { Font } from '@/js/api';
import useFormFieldAutoSave from '@/js/composables/useFormFieldAutoSave';
import { useUserStore } from '@/js/stores/user';

export default defineComponent({
  name: 'AccountFormFont',
  props: {
    disabled: { type: Boolean, default: false },
  },
  setup() {
    const userStore = useUserStore();
    const font = computed(() => userStore.user?.font ?? Font.SERIF);
    const save = (font: Font) => userStore.update({ font });
    const { formValue, saving } = useFormFieldAutoSave({
      value: font,
      save,
    });
    const inputId = `font-${uuid()}`;
    const inputs = [
      {
        label: 'Serif',
        value: Font.SERIF,
        id: `${inputId}-${Font.SERIF}`,
      },
      {
        label: 'Sans Serif',
        value: Font.SANS,
        id: `${inputId}-${Font.SANS}`,
      },
      {
        label: 'Monospace',
        value: Font.MONOSPACE,
        id: `${inputId}-${Font.MONOSPACE}`,
      },
    ];

    return {
      formValue,
      inputs,
      saving,
      Font,
    };
  },
});
</script>
